import type { AccountInfo, IPublicClientApplication } from "@azure/msal-browser";
import { loginRequest } from "./msalConfig";

export const REDIRECT_KEY = "sonia_redirect";

// Guard a nivel de modulo: con N getToken concurrentes fallando a la vez
// (chat + aprobaciones + avatar...), solo el primero dispara el redirect.
// Esto es lo que evita la "tormenta de ventanas" que causaba el popup.
let redirectInFlight = false;

/** Solo para tests. */
export function _resetRedirectGuard(): void {
  redirectInFlight = false;
}

export function saveCurrentRoute(): void {
  try {
    sessionStorage.setItem(REDIRECT_KEY, window.location.pathname + window.location.search);
  } catch {
    /* sessionStorage puede fallar en modo privado; no es critico */
  }
}

export function consumeSavedRoute(): string | null {
  try {
    const route = sessionStorage.getItem(REDIRECT_KEY);
    if (route) sessionStorage.removeItem(REDIRECT_KEY);
    return route;
  } catch {
    return null;
  }
}

/**
 * Fallback cuando acquireTokenSilent lanza InteractionRequiredAuthError en la
 * app principal: guarda la ruta actual y redirige la pagina completa a
 * Microsoft (patron gesdoc). La promesa devuelta no resuelve nunca en el
 * camino feliz — la pagina navega. Si el redirect en si falla, propaga el
 * error y libera el guard para reintentos.
 */
export async function fallbackToRedirect(
  instance: IPublicClientApplication,
  account: AccountInfo,
): Promise<never> {
  if (!redirectInFlight) {
    redirectInFlight = true;
    saveCurrentRoute();
    try {
      await instance.acquireTokenRedirect({ ...loginRequest, account });
    } catch (err) {
      redirectInFlight = false;
      throw err;
    }
  }
  // La navegacion esta en curso: no resolver nunca para que ningun caller
  // procese una respuesta a medias.
  return new Promise<never>(() => {});
}
